// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
import { displaySuccessMessage, displayErrorMessage } from '@insticator/insticator-ui'
import store from '../store/store'
// api
import * as moderationAPI from './api/moderation'

// thunks
export const fetchModerationConfig = createAsyncThunk(
    'moderation/fetchModerationConfig',
    async ({ siteId }) => {
        const response = await moderationAPI.getModerationConfig({ siteId })
        // TODO: Add mock data for now
        return response.data
    }
);

export const updateModerationConfig = createAsyncThunk('moderation/updateModerationConfig',
    async (payload, { rejectWithValue }) => {
        const { moderationConfig } = payload
        try {
            const response = await moderationAPI.updateModerationConfig({  moderationConfigId: moderationConfig.moderationConfigId , data: moderationConfig })
            store.dispatch(displaySuccessMessage('Moderation config updated.'))
            return {...moderationConfig}
            
        } catch(err) {
            const errResponse = err.response ? rejectWithValue(err.response.data) : null
            const error = errResponse?.payload || 'There was an issue updating this moderation config'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);
